import { IApiClientOptions } from 'core';
import { AssureBaseApiClient, HTTP_METHOD } from './assure-base-api-client';
import {
    ICreateFileTransferRequest,
    ICreateFileTransferResponse,
    IDeleteFileTransferResponse,
    IGetFileTransfersResponse,
    IUpdateFileTransferResponse,
    TUpdateFileTransferRequest
} from 'dto/file-transfer.dto';

const rootPathName = 'file-transfers';

export class FileTransfersApiClient extends AssureBaseApiClient {
    constructor(options: IApiClientOptions) {
        super('fileTransfers', options);
    }

    protected getRootPath(): string {
        return rootPathName;
    }

    public async createFileTransfer(accountId: number, deviceGroupName: string, params: ICreateFileTransferRequest): Promise<ICreateFileTransferResponse> {
        return this.send<ICreateFileTransferResponse>(HTTP_METHOD.POST,
            this.getRequestOptionsWithAccountId(accountId, ``, params, `deviceGroupName=${deviceGroupName}`));
    }

    public async updateFileTransfer(accountId: number, uuid: string, params: TUpdateFileTransferRequest): Promise<IUpdateFileTransferResponse> {
        return this.send<IUpdateFileTransferResponse>(HTTP_METHOD.PUT, this.getRequestOptionsWithAccountId(accountId, uuid, params));
    }

    public async getFileTransfers(accountId: number, deviceGroupName: string): Promise<IGetFileTransfersResponse> {
        return this.send<IGetFileTransfersResponse>(HTTP_METHOD.GET, this.getRequestOptionsWithAccountId(accountId, '', { deviceGroupName }));
    }

    public async deleteFileTransfer(accountId: number, uuid: string): Promise<IDeleteFileTransferResponse> {
        return this.send<IDeleteFileTransferResponse>(HTTP_METHOD.DELETE, this.getRequestOptionsWithAccountId(accountId, uuid));
    }
}
